import { Components, Theme } from '@mui/material/styles';

export const autocompleteTheme: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    size: "small",
  },
};
